import { useEffect, useState } from 'react';
import { css } from '@emotion/react'

import styled from '@emotion/styled'
import EditForm from '../../utils/utilities/EditForm';

import { fields, initialValues, schema, additionalState, parseData } from './config';

import ShoppingCartCheckoutRoundedIcon from '@mui/icons-material/ShoppingCartCheckoutRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';

import Sidebar from './Components/Sidebar';

import { UrlParamsContext } from '../../contexts/UrlParams';

import { useParams } from 'react-router-dom';

import { nanoid } from 'nanoid';


const EditBill = () => {

  const { id } = useParams();

  const [isEdit, setIsEdit] = useState(id ? true : false);

  const [initValues, setInitValues] = useState({...initialValues, checkout_id: nanoid(8)});

  const [formFields, setFormFields] = useState([...fields.map(field => ({...field}))]);


   const additionalButtons = !isEdit ? [
    { text: "Save Bill", variant: "outlined", color: "primary", icon: <ShoppingCartCheckoutRoundedIcon />, forceClose: true, redirect: `/bills`},
    { text: "Save & Continue to Payment", variant: "contained", color: "primary", icon: <ArrowForwardRoundedIcon />, redirect: null, redirect_to_edit: true}
  ] : [{ text: "Save Bill", variant: "contained", color: "primary", icon: <ShoppingCartCheckoutRoundedIcon />, forceClose: true, redirect: `/bills`}]
  
  return (
    <UrlParamsContext.Provider value={{isEdit, setIsEdit}}>
      <EditForm title={"Bill"} initialValues={initValues} fields={formFields} schema={schema} url={"bills"} 
      sidebar={<Sidebar />} 
      parseData={parseData}
      dialog={true} // to avoid navigation
      additionalState={additionalState} collection_id="bill_id" additionalButtons={additionalButtons} submitButton={true}>
      </EditForm>
    </UrlParamsContext.Provider>
  );
}

export default EditBill;